/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TaskDto } from '../../models/task-dto';

export interface Get$Params {
  formId: string;
}

export function get(
  http: HttpClient,
  rootUrl: string,
  params: Get$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<TaskDto>>> {
  const rb = new RequestBuilder(rootUrl, get.PATH, 'get');
  if (params) {
    rb.path('formId', params.formId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TaskDto>>;
    })
  );
}

get.PATH = '/auditing/audit-history/{formId}';
